import { Box, Button, ButtonGroup } from '@chakra-ui/react';
import { Modal } from 'shared-components';

interface ReinstateOfferModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading: boolean;
}

export function ReinstateOfferModal({ isOpen, onClose, onConfirm, isLoading }: Readonly<ReinstateOfferModalProps>) {
  return (
    <Modal
      show={isOpen}
      onClose={onClose}
      title="Reinstate offer"
      footer={
        <ButtonGroup spacing={3} size={'lg'}>
          <Button onClick={onClose}>Cancel</Button>
          <Button variant="solid" isDisabled={false} onClick={onConfirm} isLoading={isLoading}>
            Reinstate offer
          </Button>
        </ButtonGroup>
      }
    >
      <Box>
        The offer will be reinstated to Applied status. You will then be able to reissue the offer when you are ready
        to.
      </Box>
    </Modal>
  );
}
